export const initializeDashboardAfterReferralCapture = async (
  captureReferral: () => void,
  initializeDashboard: () => void | Promise<void>,
) => {
  captureReferral();
  await initializeDashboard();
};

/**
 * The Brand callback may carry one-use provider credentials. It must settle and
 * scrub the location before referral capture or any module that initializes
 * analytics is loaded.
 */
export const initializeDashboardAfterBrandCallback = async (
  consumeBrandCallback: () => Promise<void>,
  captureReferral: () => void,
  initializeDashboard: () => void | Promise<void>,
) => {
  await consumeBrandCallback();
  await initializeDashboardAfterReferralCapture(
    captureReferral,
    initializeDashboard,
  );
};

export const isBrandCallbackStartup = (
  location: Pick<Location, "pathname" | "search" | "hash">,
) =>
  location.pathname === "/brand/register" &&
  Boolean(location.search || location.hash);

/**
 * The static callback shell is the only DOM allowed while one-use provider
 * credentials are being consumed. It is removed immediately before React
 * mounts, after callback consumption and URL replacement have settled.
 */
export const removeBrandCallbackStartupShell = (
  document: Pick<Document, "getElementById">,
) => document.getElementById("brand-callback-startup")?.remove();
